import { Select } from '@mui/material'
import styled from 'styled-components'

export const SelectLightBorder = styled(Select)`
  border-radius: 10px;
  min-height: 33px;
  max-height: 33px;
  font-size: 14px;
`
